const actionTypes = require('constants/actionTypes');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');

const getStatusJointHolders = (dispatch, accessToken) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    Api.get(apiURLBuilder.getURL('jointHolderStatus'), requestData)
        .then(response => {
            const data = response.body;
            if (data.status === 'OK') {
                dispatch({
                    type: actionTypes.FETCH_JOINT_HOLDERS_SUCCESS,
                    data: data.jointHolders,
                });
            }
        })
        .catch(error => {
            dispatch({
                type: actionTypes.FETCH_JOINT_HOLDERS_FAILURE,
                error,
            });
        });
};

const statusHolders = accessToken => {
    return function (dispatch) {
        getStatusJointHolders(dispatch, accessToken);
    };
};

export default {
    statusHolders,
};
